<template>
  <v-row justify="center" class="c-add-routes">
    <v-dialog
      v-model="dialog"
      @click:outside="closedModal()"
      scrollable
      max-width="400"
    >
      <v-card>
        <v-card-title>{{ dialog_title }} {{ `(${count_routes}/${max_count_routes})` }}</v-card-title>
        <v-card-text class="pt-5">
          <v-select
            label="Тип"
            v-model="route_type"
            :items="route_types_list"
            item-text="title"
            item-value="id"
            color="success"
            item-color="success"
            dense
            hide-details
            @change="route = null"
            :disabled="count_routes >= 3"
          ></v-select>
        </v-card-text>
        <v-card-text class="pt-5">
          <v-autocomplete
            label="Маршрут"
            v-model="route"
            :items="routes_filter"
            dense
            class="mb-1"
            color="success"
            item-color="success"
            hide-details
            :disabled="route_type == null || count_routes >= 3"
          >
            <template v-slot:item="{ item }">
              <span
                :title="titleItemByRoute(item.dtransport_id)"
                :class="{ 'no-dtransport-id': !dTransportIdValid(item.dtransport_id) }"
              >{{ item.text }}</span>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-btn
            text
            @click="closedModal()"
          >
            Закрити
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="px-3"
            color="success"
            @click="addRoute()"
            :disabled="route == null || count_routes >= 3"
          >
            Додати
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import dTransportIdValid from '@/mixins/dTransportIdValid'
import { sortUniversal } from '@/helpers/base/sort'
import { addDisableActiveRoute } from '@/helpers/routes'
import { config_routes } from '@/config'
export default {
  name: 'c-add-routes',
  mixins: [dTransportIdValid],
  props: {
    count_routes: {
      type: Number,
      default: 0
    },
    rect_id: {
      type: Number,
      default: 0
    },
    max_count_routes: {
      type: Number,
      default: config_routes.max_count_in_map
    },
    dialog_title: {
      type: String,
      default: 'Додати маршрут'
    },
  },
  data() {
    return {
      dialog: false,
      route: null,
      route_type: null,
      routes_select_list: []
    }
  },
  computed: {
    routes_list() {
      return this.$store.getters.ROUTES_SELECT
    },
    route_types_list() {
      return this.$store.getters.ROUTES_TYPE
    },
    routes_filter() {
      let array = this.routes_select_list.filter(item => item.route_type == this.route_type)
      return sortUniversal(array, 'number')
    }
  },
  watch: {
    routes_list(val_new, val_old) {
      if(val_new.length != val_old.length) {
        this.updateRoutesSelectList()
      }
    }
  },
  methods: {
    openModal() {
      if(this.count_routes <= this.max_count_routes) {
        this.dialog = true
        this.updateRoutesSelectList()
      }
    },
    closedModal() {
      this.dialog = false
      this.resetForm()
    },
    titleItemByRoute(dtransport_id) {
      return !this.dTransportIdValid(dtransport_id) ? `Немає ТЗ для відображення` : ``
    },
    resetForm() {
      this.route = null
      this.route_type = null
    },
    updateRoutesSelectList() {
      let routes = this.routes_list
      let routes_active = this.$store.getters.RECT_ROUTES_BY_RECT_ID(this.rect_id)
      // Добавляем disabled маршрутам, которые уже отображены на этой карте
      routes = addDisableActiveRoute(routes, routes_active)
      this.routes_select_list = [...routes]
    },

    addRoute() {
      let obj = this.routes_filter.find(i => i.value == this.route)
      this.$emit('returnRoute', obj)
      this.closedModal()
    }
  }
}
</script>

<style lang="scss">
  .c-add-routes {
    position: relative;
    display: block;
  }
</style>